import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, ProgressModule, SvgIconModule, TableModule, UtilsModule } from '@mtgame/ui';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { TournamentStageWidgetComponent } from './tournament-stage-widget.component';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    ProgressModule,
    UtilsModule,
    RouterModule,
    SharedModule,
    ButtonModule,
    TableModule
  ],
  declarations: [
    TournamentStageWidgetComponent,
  ],
  exports: [
    TournamentStageWidgetComponent,
  ]
})
export class TournamentStageWidgetModule {}
